<button class="btn btn-lg btn-flat" title="View movements" (click)="goToDetail()" [disabled]="!canShowDetails">
  <em class="icon">list</em>
</button>
